import loading from '../img/loading.gif';

export default function Portifolio(){
    return(
        <section className='portifolio'>          
          <h3 className='sectionTitle' id="portfolio"> {" What I've done ? (Portfolio)"} </h3> <br/>
          <div className="port">
            <div>
              <figure>
                <img src={loading} alt='#'/>
              </figure>
              <b> Fly </b> <br/> 
              <span> a kind of e-commerce... it stills a prototype </span> <br/> 
              <a href="https://fly.coolpage.biz" target='_blank'> click to see </a> 
            </div>
            <div>
              <figure>
                <img src={loading} alt='#'/>
              </figure>
              <b> MozCap </b> <br/> 
              <span> a kind of landing page</span> <br/> 
              <a href="https://fly.coolpage.biz" target='_blank'> click to see </a> 
            </div>
            <div>
              <figure>
                <img src={loading} alt='#'/>
              </figure>
              <b> AZ-Race </b> <br/> 
              <span> a kind of racing game </span> <br/> 
              <a href="#" target='_blank'> click to see </a> 
            </div>
            <div>
              <figure>
                <img src={loading} alt='#'/>
              </figure>
              <b> CodeVS </b> <br/> 
              <span> a kind of game of dev vs dev </span> <br/> 
              <a href="#" target='_blank'> click to see </a> 
            </div>
            <div>
              <figure>
                <img src={loading} alt='#'/>
              </figure>
              <b> MOZCOMM </b> <br/> 
              <span> a kind of web for mozambican dev communities </span> <br/> 
              <a href="#" target='_blank'> click to see </a> 
            </div>
          </div>
        </section>
    );
}